/** Copy — TNO Media Lab para creadores: producimos, estrenamos en vivo y dejamos el show en la network. */
export const mediaLabWho = {
  title: 'TNO Media Lab: la productora de shows de TNO Network',
  subtitle:
    'Tú llegas con el programa. El Lab pone el estudio, el equipo y la salida al aire: estrenamos en el streaming en vivo de TNO y publicamos tu show en todas las plataformas — on-demand, web, YouTube, Instagram, TikTok, Facebook y más.',
  description:
    'No armas un canal ni contratas productora por fuera. Nos encargamos de cámaras, sonido, streaming y publicación multicanal. Tú conduces; nosotros producimos y subimos. El día del estreno tu episodio sale en la señal en vivo y el mismo master puede quedar en on-demand, clips, tnonetwork.com y en tus canales de redes y video.',
};

export const mediaLabWhy = {
  title: 'Tú conduces. Nosotros producimos.',
  description:
    'Traes tu idea y tu voz. TNO Media Lab graba en estudio broadcast, pone el episodio al aire en el streaming en vivo el día del estreno y se ocupa del resto: post, clips, artículo, hub y publicación en todas las plataformas donde tu audiencia ya está. No dejas de tener antena: tu premiere es en vivo. Y no te quedas solo en esa hora: el show sigue trabajando en on-demand, redes y video.',
  ctaText: 'Producir mi show',
};

export const mediaLabBenefits = {
  overline: 'Qué te llevas',
  title: 'Tú te sientas. El Lab se encarga del resto.',
  subtitle:
    'Estudio, estreno en vivo, catálogo on-demand, clips y publicación en todas las plataformas. Una sola producción, toda la network.',
  items: [
    {
      title: 'Estreno en el streaming en vivo',
      subtitle:
        'Tu episodio sale al aire en la señal continua de TNO Network. Hay premiere, hay antena, hay momento. No es un archivo que se sube en silencio.',
      colorKey: 'blue',
      iconType: 'innovation',
    },
    {
      title: 'Producción de punta a punta',
      subtitle:
        'Multicámara, audio, operación de streaming y publicación. Tú llegas a conducir; el equipo técnico y editorial del Lab hace el resto.',
      colorKey: 'teal',
      iconType: 'community',
    },
    {
      title: 'El show queda en la network y en tus plataformas',
      subtitle:
        'Después del vivo, el episodio queda en on-demand, los mejores minutos salen a clips y tnonetwork.com concentra artículo, show notes y hub. También puedes subirlo a YouTube, Instagram, TikTok, Facebook y donde tengas canal.',
      colorKey: 'amber',
      iconType: 'growth',
    },
    {
      title: 'Comercialización de tu show',
      subtitle:
        'No vendemos un hueco en la señal. Vendemos tu programa: host-read, miniatura, artículo y clips dentro del nicho que busca el anunciante.',
      colorKey: 'pink',
      iconType: 'digest',
    },
  ],
};

export const mediaLabValues = {
  overline: 'cómo producimos',
  title: 'Grabas aquí. Estrenas en vivo. El show sigue.',
  hideAdnHeading: true,
  subtitle:
    'La señal de TNO está al aire. Tu programa se produce en el Lab, se estrena en ese streaming y el mismo master alimenta on-demand, clips, tnonetwork.com y todas las plataformas donde quieras publicar.',
  items: [
    {
      title: 'Estudio listo para ti',
      subtitle:
        'Agenda tu bloque, siéntate y conduce. Cámaras, luces, audio y operación de streaming los ponemos nosotros.',
    },
    {
      title: 'Premiere en la señal',
      subtitle:
        'El episodio sale en el streaming en vivo de TNO el día del estreno. Tu audiencia tiene hora y tu marca tiene antena.',
    },
    {
      title: 'Un master, toda la network y todas las plataformas',
      subtitle:
        'Del mismo grabado salen el video completo, clips con subtítulos, miniatura, artículo, newsletter y la publicación en YouTube, Instagram, TikTok, Facebook y el ecosistema TNO. Tú no montas ese flujo.',
    },
  ],
};

export const mediaLabPlaybook = {
  overline: 'Cómo trabajamos contigo',
  title: 'Del briefing al estreno, el Lab lo opera',
  subtitle:
    'Tú traes el show. Nosotros producimos, salimos al aire y dejamos el episodio trabajando en la network.',
  pillars: [
    {
      step: '01',
      title: 'Llegas con tu programa',
      text:
        'Definimos formato, nicho e identidad. Tú eres el host; el Lab es la productora. No te pedimos que armes estudio, canal ni equipo técnico.',
    },
    {
      step: '02',
      title: 'Grabamos y operamos',
      text:
        'Preproducción, estudio multicámara, audio y streaming. El día de grabación tú conduces; operación y publicación las cubre el Lab.',
    },
    {
      step: '03',
      title: 'Estreno en vivo + catálogo multicanal',
      text:
        'El episodio se estrena en el streaming en vivo de TNO. Después queda on-demand, en clips, en tnonetwork.com y puede subirse a YouTube, Instagram, TikTok, Facebook y el resto de plataformas donde tengas presencia.',
    },
    {
      step: '04',
      title: 'Tu show se comercializa',
      text:
        'Patrocinio 360 alrededor de tu programa: mención en vivo, logo, artículo y clips. El anunciante compra tu nicho, no un espacio genérico.',
    },
  ],
};

export const mediaLabMetrics = [
  {
    title: 40,
    label: 'Producciones originales bajo el paraguas TNO',
    subtitle: 'Shows grabados y operados en Media Lab.',
    suffix: '+',
    icon: 'OndemandVideoIcon',
  },
  {
    title: 25,
    label: 'Shows con identidad propia en la network',
    subtitle: 'Cada uno con estreno en vivo y vida on-demand.',
    suffix: '+',
    icon: 'LiveTvIcon',
  },
  {
    title: 30000,
    label: 'Visitas al hub TNO (escrito, on-demand y digest)',
    subtitle: 'Donde tu episodio sigue trabajando después del vivo.',
    suffix: '+',
    icon: 'LanguageIcon',
  },
  {
    title: 90000,
    label: 'Alcance en redes para clips y Shorts',
    subtitle: 'El Lab recorta; tú no montas el flujo de clips.',
    suffix: '+',
    icon: 'InstagramIcon',
  },
];

export const mediaLabDistribution = {
  overline: 'Distribución multicanal',
  title: 'Una producción. Todas las plataformas.',
  subtitle:
    'No te quedas solo en el estreno en vivo. El Lab prepara el master y los clips para que tu show pueda subirse y publicarse donde ya está tu audiencia — dentro de TNO Network y fuera de ella.',
  note:
    'Tú defines dónde quieres estar. Nosotros entregamos los archivos listos y, cuando aplica, gestionamos la publicación en el ecosistema TNO y en tus canales.',
  platforms: [
    { name: 'Streaming en vivo TNO', detail: 'Premiere en la señal continua de la network.' },
    { name: 'On-demand TNO', detail: 'Episodio completo en el catálogo de la red.' },
    { name: 'tnonetwork.com', detail: 'Hub, artículo, show notes y TNO Digest.' },
    { name: 'YouTube', detail: 'Episodio largo, Shorts y canal propio.' },
    { name: 'Instagram', detail: 'Reels, historias y feed.' },
    { name: 'TikTok', detail: 'Clips verticales con subtítulos.' },
    { name: 'Facebook', detail: 'Video nativo y difusión en página.' },
    { name: 'Spotify / Apple Podcasts', detail: 'Master de audio para podcast cuando el formato lo requiere.' },
  ],
};

export const mediaLabAreYouReady = {
  headline: 'Trae tu show. El Lab lo produce.',
  subheadline: '¿Listo para grabar aquí, estrenar en vivo y publicar en todas las plataformas?',
  body:
    'Tú llegas con la voz. TNO Media Lab produce, opera el streaming el día del estreno y deja el episodio en on-demand, clips, tnonetwork.com y en todas las plataformas donde quieras publicar. TNO Network distribuye y comercializa por nicho. Planes prepago.',
  ctaPrimary: 'Producir mi show',
  ctaSecondary: 'TNO Network',
  ctaSecondaryHref: 'https://www.tnonetwork.com',
  footerText: '© TNO Network 2026 | TNO Media Lab | Network de contenidos.',
};
